import React from "react";
import Button from "../../Button";
import Icon from "../../Icon";
import { useDispatch } from "react-redux";
import { updateMobileSync } from "../../../store/actions/suites";

export const MobileDownloadIcon = ({ property: {mobileSyncAllowed, id}, onClick }) => {
  const dispatch = useDispatch();
  return (
    <Button 
      color="semantic"
      onClick={() => {
        dispatch(updateMobileSync(id, !mobileSyncAllowed));
        onClick && onClick()
        }
      }
    >
      <Icon 
        glyph="mobile" 
        style={{color: mobileSyncAllowed ?  'var(--color-teal)' : '#f00'}} 
        weight={mobileSyncAllowed ? "solid" : "light"}
      />
    </Button>
  );
}
